import React, {Component} from 'react';
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
import Select from "../../local_node_modules/react-select"
import Alert from "react-s-alert";
import {Col, Label, Row} from "reactstrap";
import './MemberList.css';
import {API_BASE_URL} from "../../constants";
import LoadingIndicator from "../../common/LoadingIndicator";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";

class MemberTransfer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            isLoading: false,
            authRoles: [],
            cities: [],
            fieldsDisabled: true,
            //fieldsDisabled: false,
            outstandingAccruals: [],
            mode: this.props.mode,
            hasTransfer: false,
            memberInfo: {
                id: null,
                ad: "",
                soyad: "",
                tcKimlikNo: "",
                dogumTarihi: "",
                kimlikTipi: "",
                cuzdanKimlikSeriNo: "",
                kayitNo: "",
                kimlikSonGecerlilikTarihi: "",
                babaAdi: "",
                anaAdi: "",
                dogumYeri: "",
                medeniHali: "",
                kanGrubu: "",
                eposta: "",
                evTel: "",
                gsmTel: "",
                isTel: "",
                isAdres: "",
                ikametAdres: "",
                odaKayitTarihi: "",//
                odaSicilNo: "",//
                universite: "",
                mezuniyetTarihi: "",
                diplomaNo: "",
                ruhsatTarihi: "",
                ruhsatNo: "",
                vergiDairesiAd: "",
                vergiNo: "",
                fotoFile: "",
                kimlikCuzdanFile: "",
                adliSicilFile: "",
                ruhsatnameFile: "",
                diplomaFile: "",
                ikametgahFile: "",
                basvuruDurumu: "",
                basvuruReddedilmeSebebi: "",
                ruhsatAktif: false,
                uyelikAktif: false,
                uyelikPasiflikNedeni: "",
                user_id: "",
                transferTo: "",
                city: {
                    id: null,
                    plakaKod: null,
                    ad: null,
                    oda: {
                        id: null,
                        ad: null,
                        adres: null,
                        telefonNo: null,
                        email: null,
                        webSitesiURL: null,
                        kurulusKararNo: null
                    }
                }
            },
        };

        this.transferMember = this.transferMember.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
        this.listCities = this.listCities.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.listOutstandingAccruals = this.listOutstandingAccruals.bind(this);
    }

    async componentDidMount() {
        if (this.props.selectedMember) {
            let selectedMember = deepCopyObject(this.props.selectedMember);
            let hasTransfer = false;
            if (selectedMember.transferTo !== null) {
                hasTransfer = true;
            }
            this.setState({memberInfo: selectedMember, hasTransfer: hasTransfer});
        }
        await this.listCities();
        await this.listOutstandingAccruals();
    }

    async listCities() {
        let self = this;
        let params = {
            url: API_BASE_URL + "/city",
            method: "get",
        };
        request(params)
            .then(function (response) {
                let cities = response.data;
                self.setState({
                    cities,
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    async listOutstandingAccruals() {
        let self = this;
        let fieldsDisabled = true;
        let params = {
            url: API_BASE_URL + "/accrual/outstandingAccrualsAfterDueDate/" + this.props.selectedMember.id,
            method: "get",
        };
        console.log(params.url);
        request(params)
            .then(function (response) {
                //console.log("outstandingAccruals",response.data);
                let outstandingAccruals = response.data;
                if (Array.isArray(outstandingAccruals) && outstandingAccruals.length === 0) {
                    fieldsDisabled = false;
                }
                self.setState({
                    outstandingAccruals, fieldsDisabled
                });
            }).catch(function (error) {
            showAxiosError(error);
        });
    }

    onChangeSelect(name, value) {
        let memberInfo = this.state.memberInfo;
        if (value === null) {
            memberInfo[name] = null
        } else {
            memberInfo[name] = value.value;
        }
        this.setState({memberInfo});
    }

    validateMemberInfo() {
        let memberInfo = this.state.memberInfo;
        let errorMessage = '';
        if (memberInfo.transferTo === null || memberInfo.transferTo.toString() === '') {
            errorMessage += 'Üyenin Transfer Edileceği Şehir(Oda) Seçiniz!</br>';
        }
        console.log(errorMessage);
        return errorMessage;
    }

    transferMember() {
        let self = this;
        let params;
        let message;
        let validity = this.validateMemberInfo();
        if (validity === '') {
            self.setState({isLoading: true});
            let member = deepCopyObject(this.state.memberInfo);
            message = 'Üye Transfer Bilgisi Alıcı Odaya İletildi. Üye Karşı Oda Tarafından Kabul Edilene Kadar Üyelik Bilgilerinde Değişiklik Gerçekleşmeyecektir.'
            params = {
                url: API_BASE_URL + "/uye/transfer-to/" + member.id + "/" + member.transferTo,
                method: 'get'
            };
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 20000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch();
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
    }

    cancelTransferMember() {
        let self = this;
        let params;
        let message;
        let validity = this.validateMemberInfo();
        if (validity === '') {
            self.setState({isLoading: true});
            let member = deepCopyObject(this.state.memberInfo);
            message = 'Üye Transfer İşlemi İptal Edildi'
            params = {
                url: API_BASE_URL + "/uye/cancel-transfer/" + member.id,
                method: 'get'
            };
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 20000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch();
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }
    }

    cancelProcess() {
        this.props.cancelProcess();
    }

    handleLogout() {
        this.props.handleLogout();
    }

    render() {
        return (
            <div>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">Üye Bilgileri</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-body mt-1">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-2">TC Kimlik No:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.tcKimlikNo}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Ad:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Soyad:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.soyad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Sicil No:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.odaSicilNo}</Label>
                            </div>

                            <div className="row">
                                <Label className="col-sm-2">Şehir:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.city.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Oda:</Label>
                                <Label className="col-sm-10">{this.state.memberInfo.city.oda.ad}</Label>
                            </div>
                            <div className="row">
                                <Label className="col-sm-2">Borç Bilgileri:</Label>
                                <Row className="col-sm-10">
                                    <Col sm="12" style={{
                                        paddingTop: "0px",
                                        paddingRight: "15px",
                                        paddingLeft: "15px",
                                        maxHeight: '500px',
                                        overflow: "auto"
                                    }}>
                                        <table className="" style={{textAlign: 'center', paddingBottom: "5px"}}>
                                            <thead>
                                            <tr style={{backgroundColor: '#ebedf0'}}>
                                                <th width="5%">#</th>
                                                <th>Dönem</th>
                                                <th>Tip</th>
                                                <th>Meblağ</th>
                                                <th>Son Ödeme Tarihi</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.state.outstandingAccruals && this.state.outstandingAccruals.map((document, index) =>
                                                <tr key={index + "_" + document.relatedYear + "_"}>
                                                    <td>{index + 1}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{
                                                        <TextOverFlowTooltip text={document.relatedYear || "-"}
                                                                             maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{
                                                        <TextOverFlowTooltip
                                                            text={document.accrualType === 'YearlyFee' ? 'Yıllık Aidat' : ('Oda G. Aidatı' || "-")}
                                                            maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{
                                                        <TextOverFlowTooltip text={document.amount + ' ₺' || "-"}
                                                                             maxLength={30}/>}</td>
                                                    <td style={{margin: "0px", textAlign: "center"}}>{
                                                        <TextOverFlowTooltip
                                                            text={document.accrualDueDate && new Date(document.accrualDueDate).toLocaleDateString('tr') || "-"}
                                                            maxLength={30}/>}</td>
                                                </tr>
                                            )}
                                            {(this.state.outstandingAccruals && this.state.outstandingAccruals.length === 0) &&
                                            <tr>
                                                <td colSpan="8">Kayıt bulunamadı</td>
                                            </tr>
                                            }
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col sm="12">
                                        <p/>
                                        <p style={{float: "left"}}>
                                            {this.state.outstandingAccruals
                                                ?
                                                (this.state.outstandingAccruals.length !== 0)
                                                    ?
                                                    <span style={{
                                                        color: "red",
                                                        fontWeight: "bold"
                                                    }}>{'Toplam ' + this.state.outstandingAccruals.length + ' Adet Borç Kaydı Bulundu. Üye Transfer Edilemez!'}</span>
                                                    :
                                                    <span style={{
                                                        color: "green",
                                                        fontWeight: "bold"
                                                    }}>{'Son Ödeme Tarihi Geçmiş Borç Kaydı Bulunamadı.'}</span>
                                                :
                                                <span style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}>{'Borç Kayıtları Sorgulanıyor!'}</span>

                                            }
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </div>
                </div>


                <div className='card-header'>
                    <h4 className="card-title">Üyenin Transfer Edileceği Şehir(Oda)</h4>
                </div>
                <div className="memberTransferForm-container">
                    <div className="card-bod mt-1y">
                        <div className="FormRenk col-sm-12">
                            <div className="row">
                                <Label className="col-sm-2">İl:</Label>
                                <div className="col-sm-10 form-group">
                                    <Select
                                        disabled={this.state.hasTransfer}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="İl seçiniz."
                                        isClearable={false}
                                        isSearchable={false}
                                        name="city"
                                        id="tCity"
                                        ref="tCity"
                                        style={{width: 120}}
                                        inputProps={{'vdata': "required"}}
                                        options={this.state.cities.map(city => ({
                                            value: city.id,
                                            label: city.ad
                                        }))}
                                        onChange={(value) => this.onChangeSelect("transferTo", value)}
                                        value={this.state.memberInfo.transferTo}/>
                                </div>
                            </div>

                            <div className="row">
                                <Label className="col-sm-2">Oda:</Label>
                                <Label
                                    className="col-sm-10">{(this.state.memberInfo.transferTo && this.state.cities.length !== 0) ?
                                    this.state.cities[this.state.memberInfo.transferTo - 1].oda.ad :
                                    "İl Seçiniz!"}
                                </Label>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="new-button-holder">
                    {
                        !this.state.hasTransfer
                            ?
                            <button type="button"
                                    onClick={() => this.transferMember()}
                                    disabled={this.state.isLoading || this.state.fieldsDisabled}
                                    data-toggle="tooltip" data-placement="bottom" title="Onayla"
                                    rel="tooltip" className="save">Transfer İşlemini Onayla</button>
                            :
                            <button type="button"
                                    onClick={() => this.cancelTransferMember()}
                                    disabled={this.state.isLoading}
                                    data-toggle="tooltip" data-placement="bottom" title="İptal"
                                    rel="tooltip" className="cancel">Transfer İşlemini İptal Et</button>
                    }
                </div>
            </div>
        )
    }
}

export default MemberTransfer;


// WEBPACK FOOTER //
// ./src/page/memberList/MemberTransfer.js